import React from 'react';

const Tweet = ({ children, href }) => {
  return children ? (
    <button
      className={`block w-full min-w-[250px] max-w-[550px] mx-auto rounded-lg isolate overflow-hidden border border-brand-gray-2 my-5 [&_p]:!my-0 ${
        href ? '' : 'pointer-events-none'
      }`}
      onClick={() => href && window.open(href, '_blank')}
      aria-label="tweet"
      role="button"
    >
      <div className="pointer-events-none">{children}</div>
    </button>
  ) : (
    <div className="bg-white flex flex-col justify-center items-center rounded-lg isolate overflow-hidden p-4 my-5 mx-auto max-w-[550px] border border-brand-gray-2 pointer-events-none">
      <div className="w-full flex justify-between">
        <div className="flex items-center">
          <span className="w-12 h-12 bg-brand-blue-1 rounded-full"></span>
          <span className="w-2"></span>
          <span className="w-5 h-5">
            <svg
              viewBox="0 0 22 22"
              aria-label="Verified account"
              role="img"
              fill="#1D9BF0"
              className="r-1cvl2hr r-4qtqp9 r-yyyyoo r-1xvli5t r-9cviqr r-f9ja8p r-og9te1 r-bnwqim r-1plcrui r-lrvibr"
              data-testid="icon-verified"
            >
              <g>
                <path d="M20.396 11c-.018-.646-.215-1.275-.57-1.816-.354-.54-.852-.972-1.438-1.246.223-.607.27-1.264.14-1.897-.131-.634-.437-1.218-.882-1.687-.47-.445-1.053-.75-1.687-.882-.633-.13-1.29-.083-1.897.14-.273-.587-.704-1.086-1.245-1.44S11.647 1.62 11 1.604c-.646.017-1.273.213-1.813.568s-.969.854-1.24 1.44c-.608-.223-1.267-.272-1.902-.14-.635.13-1.22.436-1.69.882-.445.47-.749 1.055-.878 1.688-.13.633-.08 1.29.144 1.896-.587.274-1.087.705-1.443 1.245-.356.54-.555 1.17-.574 1.817.02.647.218 1.276.574 1.817.356.54.856.972 1.443 1.245-.224.606-.274 1.263-.144 1.896.13.634.433 1.218.877 1.688.47.443 1.054.747 1.687.878.633.132 1.29.084 1.897-.136.274.586.705 1.084 1.246 1.439.54.354 1.17.551 1.816.569.647-.016 1.276-.213 1.817-.567s.972-.854 1.245-1.44c.604.239 1.266.296 1.903.164.636-.132 1.22-.447 1.68-.907.46-.46.776-1.044.908-1.681s.075-1.299-.165-1.903c.586-.274 1.084-.705 1.439-1.246.354-.54.551-1.17.569-1.816zM9.662 14.85l-3.429-3.428 1.293-1.302 2.072 2.072 4.4-4.794 1.347 1.246z"></path>
              </g>
            </svg>
          </span>
        </div>
        <span className="w-6 h-6">
          <svg
            viewBox="0 0 24 24"
            aria-hidden="true"
            className="r-18jsvk2 r-4qtqp9 r-yyyyoo r-6zzn7w r-19fsva8 r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-q1j0wu"
          >
            <g>
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
            </g>
          </svg>
        </span>
      </div>
      <div className="w-6 h-6">
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          className="r-14j79pv r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-1plcrui r-lrvibr"
        >
          <g>
            <path d="M13.5 8.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5S11.17 7 12 7s1.5.67 1.5 1.5zM13 17v-5h-2v5h2zm-1 5.25c5.66 0 10.25-4.59 10.25-10.25S17.66 1.75 12 1.75 1.75 6.34 1.75 12 6.34 22.25 12 22.25zM20.25 12c0 4.56-3.69 8.25-8.25 8.25S3.75 16.56 3.75 12 7.44 3.75 12 3.75s8.25 3.69 8.25 8.25z"></path>
          </g>
        </svg>
      </div>
      <div className="text-base text-black">Tweet not found. It was probably deleted.</div>
    </div>
  );
};

export default Tweet;
